import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY } from '@core/configs';
import { ButtonType, DpadKeyCode, DpadZoneType, Mode } from '@core/constants';
import { DpadZoneState } from '@core/models/models';
import { AuthService } from '@core/services/apis';
import { AfterLoginService } from '@core/services/apis/after-login.service';
import { LocalStorageService, SessionContextService } from '@core/services/common';
import { DpadControlService } from '@core/services/common/dpad-control.service';
import _ from 'lodash';
import { Subscription } from 'rxjs';

@Component({
  selector: 'caremoni-office-select-tv',
  templateUrl: './office-select-tv.component.html',
  styleUrl: './office-select-tv.component.scss',
  encapsulation: ViewEncapsulation.None
})

export class OfficeSelectTvComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() authOfficeList: any[] = [];
  subscription: Subscription = new Subscription();
  lstOfficeNames: any[] = [];
  buttonType = ButtonType;
  DpadZoneType = DpadZoneType;
  
  constructor(
    private sessionContextService: SessionContextService,
    private afterLoginService: AfterLoginService,
    private dpadControlService: DpadControlService,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.bindData();
    this.dpadSbr();
    this.dpadControlService.clearSelectItemDpad();
    this.dpadControlService.selectItemDpad();
  }

  ngOnDestroy(): void { 
    this.subscription.unsubscribe(); 
  }

  ngAfterViewInit(){
    this.dpadControlService.initScreenNonLayout({screenStyle: 'corp-select'});
  }
  
  async bindData(){
    if(this.authOfficeList.length == 1) await this.pickOffice(this.authOfficeList[0]);
    else this.lstOfficeNames = this.authOfficeList?.map(x=>x.officeNm) || [];
  }

  dpadSbr(){
    [
      this.dpadControlService.dZoneState$.subscribe((state: DpadZoneState) => {
        if(state.dKey == DpadKeyCode.KEYCODE_BACK) this.authService.logout();
      })
    ].forEach(sub => this.subscription.add(sub));
  }

  async pickOffice(office: any) {
    const corpPrefix = this.sessionContextService.getCorpPrefix();
    await this.afterLoginService.afterSelectedOffice(office, corpPrefix);
  }

  async onSelectOffice(idx:any){
    if (this.authOfficeList?.length > 0) {
      const office = this.authOfficeList[idx];
      await this.pickOffice(office);
    }
  }
}
